<template>
  <v-layout
    class="warehouse-card"
    :wrap="smAndDown"
  >
    <v-flex
      class="family-card-info_bordered"
      md6
      :xs12="smAndDown"
    >
      <v-layout
        class="warehouse-card__item"
        :wrap="smAndDown"
      >
        <v-flex
          xl2
          md4
          sm5
          xs6
          class="warehouse-card__key"
        >
          {{ locationTitle | addColons }}
        </v-flex>
        <v-flex
          xl10
          md8
          sm7
          xs6
        >
          {{ location }}
        </v-flex>
      </v-layout>
      <v-layout class="warehouse-card__item">
        <v-flex
          xl2
          md4
          sm5
          xs6
          class="warehouse-card__key"
        >
          {{ $t('label.address') | addColons }}
        </v-flex>
        <v-flex
          xl10
          md8
          sm7
          xs6
        >
          {{ address }}
          {{ warehouse.postal_code | postalCode }}
          {{ warehouse.city }}
        </v-flex>
      </v-layout>
      <v-layout
        v-if="isSupporting"
        class="warehouse-card__item"
        :wrap="smAndDown"
      >
        <v-flex
          xl2
          md4
          sm5
          xs6
          class="warehouse-card__key"
        >
          {{ $t('label.quantity') | addColons }}
        </v-flex>
        <v-flex
          xl10
          md8
          sm7
          xs6
        >
          {{ familiesAmount }} {{ $t('label.families') }}
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      md6
      :xs12="smAndDown"
      :pl-4="!smAndDown"
      :mt-3="smAndDown"
    >
      <v-layout class="warehouse-card__item">
        <v-flex
          xl2
          md3
          sm5
          xs6
          class="warehouse-card__key"
        >
          {{ $t('label.status') | addColons }}
        </v-flex>
        <v-flex
          v-if="warehouse.status != null"
          xl10
          md9
          sm7
          xs6
        >
          <FamilyStatus
            :mobile="false"
            :status="warehouse.status"
          />
        </v-flex>
      </v-layout>
      <v-layout
        v-if="sectionVisible"
        class="mt-4"
        :wrap="$vuetify.breakpoint.smAndDown"
      >
        <v-flex v-if="editButtonVisible">
          <v-btn
            color="sz_violet"
            class="mr-0 text-xs-center"
            @click="redirectToForm"
          >
            {{ $t('buttons.edit') }}
          </v-btn>
        </v-flex>
        <v-flex v-if="warehouseVerifyPermissions.acceptable">
          <v-btn
            color="sz_violet"
            class="mr-0 text-xs-center"
            :loading="acceptLoading"
            @click="accept"
          >
            {{ $t('buttons.approve_and_publish') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import filters from '@/constants/filters';
import FamilyStatus from '@/components/widgets/dataTable/FamilyStatus';
import permissions from '@/constants/permissions';
import warehouseStatusesId from '@/constants/warehouse/warehouseStatusesId';

export default {
    name: 'BaseWarehouseData',
    components: { FamilyStatus },
    filters: {
        ...filters
    },
    props: {
        warehouse: {
            default: null
        },
        rejon: {
            default: null
        }
    },
    data () {
        return {
            acceptLoading: false,
            permissions,
            hasSupportingEditPermission: null,
            hasRejonEditPermission: null,
            warehouseStatusesId
        };
    },
    computed: {
        isSupporting () {
            return this.warehouse.warehouse_type === 'supporting';
        },
        familiesAmount () {
            return this.$store.getters['warehouse/getFamiliesInWarehouseAmount'];
        },
        smAndDown () {
            return this.$vuetify.breakpoint.smAndDown;
        },
        warehouseVerifyPermissions () {
            return this.$store.getters['warehouse/getWarehouseVerifyPermissions'];
        },
        address () {
            const _flat = this.warehouse.flat_number ? '/' + this.warehouse.flat_number : '';
            const _street = this.warehouse.street ? this.warehouse.street : '';
            return _street + ' ' + this.warehouse.building_number + _flat;
        },
        locationTitle () {
            if (this.rejon != null) {
                return this.$t('label.area');
            }
            return this.$t('label.location');
        },
        location () {
            if (this.rejon != null) {
                return this.rejon;
            }
            return this.warehouse.province.name;
        },
        canEditPublishedWarehouse () {
            if (
                this.isSupporting &&
        this.hasSupportingEditPermission &&
        this.warehouse.status.warehouse_status_id === this.warehouseStatusesId.PUBLISHED
            ) {
                return true;
            }
            if (
                !this.isSupporting &&
        this.hasRejonEditPermission &&
        this.warehouse.status.warehouse_status_id === this.warehouseStatusesId.PUBLISHED
            ) {
                return true;
            }
            return false;
        },
        sectionVisible () {
            return (
                this.warehouseVerifyPermissions.editable ||
        this.warehouseVerifyPermissions.acceptable ||
        this.canEditPublishedWarehouse
            );
        },
        editButtonVisible () {
            return this.warehouseVerifyPermissions.editable || this.canEditPublishedWarehouse;
        }
    },
    created () {
        if (this.isSupporting) {
            this.$store
                .dispatch('auth/hasPermission', this.permissions.WAREHOUSE_SUPPORTING_CHECK)
                .then((res) => {
                    this.hasSupportingEditPermission = res;
                });
        } else {
            this.$store
                .dispatch('auth/hasPermission', this.permissions.WAREHOUSE_REJON_CHECK)
                .then((res) => {
                    this.hasRejonEditPermission = res;
                });
        }
    },
    methods: {
        accept () {
            this.acceptLoading = true;
            this.$store
                .dispatch('warehouse/acceptWarehouse', this.warehouse.warehouse_id)
                .then(() => {
                    this.$emit('reload');
                })
                .finally(() => {
                    this.acceptLoading = false;
                });
        },
        redirectToForm () {
            const name =
        this.warehouse.warehouse_type === 'regional'
            ? 'edit-warehouse-data'
            : 'edit-supporting-warehouse-data';
            const warehouseName =
        this.warehouse.warehouse_type === 'regional' ? this.location : this.warehouse.warehouse_name;
            this.$store.commit('warehouses/setSelectedProvince', this.warehouse.province);
            this.$store.commit('warehouses/setSelectedRejon', {
                id: this.warehouse.wio_struct_location_id,
                name: warehouseName
            });
            const type = this.warehouse.warehouse_type === 'regional' ? 1 : 2;
            this.$store.dispatch('warehouses/setLocalIdToStorage', type);
            if (this.canEditPublishedWarehouse) {
                this.$router.push({
                    name,
                    params: {
                        canEditPublishedWarehouse: this.canEditPublishedWarehouse,
                        warehouseId: this.warehouse.warehouse_id
                    }
                });
            } else {
                this.$router.push({
                    name,
                    params: {
                        warehouseVerifyPermissions: this.warehouseVerifyPermissions,
                        warehouseId: this.warehouse.warehouse_id
                    }
                });
            }
        }
    }
};
</script>

<style scoped></style>
